"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAxiosError = exports.getAxiosError = exports.isError = exports.createError = void 0;
const clone = require("lodash/clone");
const createError = (errorMessageOrError, code = -1, type = "undefined", data = {}) => {
    if (typeof errorMessageOrError === "string")
        return { message: errorMessageOrError, code, type, data };
    return clone(Object.assign({ code, type, data }, errorMessageOrError));
};
exports.createError = createError;
const isError = (error) => {
    var _a;
    if (typeof error === "object" &&
        ((_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.length) &&
        error.message.length > 0 &&
        typeof (error === null || error === void 0 ? void 0 : error.code) === "number" &&
        typeof (error === null || error === void 0 ? void 0 : error.type) === "string")
        return true;
    return false;
};
exports.isError = isError;
const getAxiosError = (error) => error.response.data;
exports.getAxiosError = getAxiosError;
const isAxiosError = (maybeError) => {
    var _a, _b;
    if (typeof maybeError === "object" &&
        (maybeError === null || maybeError === void 0 ? void 0 : maybeError.response) &&
        ((_a = maybeError === null || maybeError === void 0 ? void 0 : maybeError.response) === null || _a === void 0 ? void 0 : _a.data) &&
        (0, exports.isError)((_b = maybeError === null || maybeError === void 0 ? void 0 : maybeError.response) === null || _b === void 0 ? void 0 : _b.data))
        return true;
    return false;
};
exports.isAxiosError = isAxiosError;
exports.default = exports.createError;
//# sourceMappingURL=createError.js.map